import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_METHOD_TRANSLATIONS } from 'api/notificationManager/methods';

export default class TranslationsRequest extends WsBaseRequest {
  constructor() {
    super(API_METHOD_TRANSLATIONS, {});
  }
}
